<template>
    <div>
        <el-form
            v-if="formData"
            :model="formData"
            :rules="rules"
            ref="formData"
            label-position="top"
			autocomplete="off"
            v-loading="dataLoading"
        >
            <div class="page-group-title"><span>负责人</span></div>
            <el-row :gutter="30">
                <el-col :xs="24" :sm="12" :xl="8">
                    <el-form-item prop="contactName" label="姓名:">
                        <el-input v-model="formData.contactName" placeholder="请输入姓名" size="medium" maxlength="40"></el-input>
                    </el-form-item>
                </el-col>
                <el-col :xs="24" :sm="12" :xl="8">
                    <el-form-item prop="telephone" label="手机:">
                        <el-input v-model="formData.telephone" placeholder="请输入手机号码" size="medium"></el-input>
                    </el-form-item>
                </el-col>
            </el-row>
            <el-row :gutter="30">
                <el-col :xs="24" :sm="12" :xl="8">
                    <el-form-item prop="contactMail" label="邮箱:">
                        <el-input v-model="formData.contactMail" placeholder="请输入邮箱" size="medium" maxlength="100"></el-input>
                    </el-form-item>
                </el-col>
            </el-row>
            <div class="page-group-title"><span>登录</span></div>
            <el-row :gutter="30">
                <el-col :xs="24" :sm="12" :xl="8">
                    <el-form-item prop="loginName" label="自定义登录名:">
                        <el-input v-model="formData.loginName" placeholder="请输入自定义登录名" size="medium" maxlength="40" autocomplete="off"></el-input>
                    </el-form-item>
                </el-col>
                <el-col :xs="24" :sm="12" :xl="8">
                    <el-form-item prop="password" label="重设登录密码:">
                        <el-input type="password" v-model="formData.password" placeholder="请输入登录密码" size="medium" maxlength="40" show-password autocomplete="off"></el-input>
                    </el-form-item>
                </el-col>				
            </el-row>
            <el-form-item>
                <!-- <el-button @click="goBack">返回</el-button> -->
                <el-button
                    type="primary"
                    @click="onSubmit"
                    :loading="btnLoading"
                    >保 存</el-button
                >
            </el-form-item> 
        </el-form>
    </div>
</template>

<script>
const defaultFormData = {
    contactMail:'',
    contactName:'',   
    loginName:'',
    name:'',
    password:'',
    telephone:'',
}
export default {
    props:{
        userId:{
            type:[Number,String],
            default:''
        },
        userType:{
            type:[Number,String],
            default:''
        },
        userName:{
            type:String,
            default:''
        }
    },
    data(){
        var checkLoginName = (rule, value, callback) => {
            const _reg = /^\d{11}$/;
            if (_reg.test(value)) {
                callback(new Error("自定义登录名不能为11位数字"));
            } else {
                callback();
            }
        }
        //验证密码
		const validatePassword = (rule, value, callback) => {
            const _reg = /^(?=.*[a-zA-Z])(?=.*\d)[^]{8,40}$/;
            if (!_reg.test(value)) {
                callback(new Error("密码必须包含数字和字母,且不能少于8位不大于40位"));
            } else {
                callback();
            }
        }
        return{
            dataLoading:false,
            btnLoading:false,
            formData:{
                ...defaultFormData
            },
            rules:{
                contactName:[{required: true, message: '请输入负责人姓名'}],
                telephone: [
                    // { required: true, message: "请输入负责人手机号码" },
                    { validator: this.$utils.validatePhone }
                ],
                contactMail:[
                    { required: true, message: "请输入负责人邮箱" },
                    { type: "email", message: "请输入正确的邮箱地址" }
                ],
                loginName:[{validator: checkLoginName}],
    //             password:[
				// 	{validator:validatePassword}
				// ],
            },
            action:{
                2:{ // 艺人
                    accountInfo:'/performer/accountInfo',
                    saveAccount:'/performer/saveAccount',
                    checkBUserPhone: '/performer/checkBUserPhone'
                },
                3:{ // 场地
                    accountInfo:'/site/accountInfo',
                    saveAccount:'/site/saveAccount',
                    checkBUserPhone: '/site/checkBUserPhone'
                },
                5:{ // 厂牌
                    accountInfo:'/brand/accountInfo',
                    saveAccount:'/brand/saveAccount',
                    checkBUserPhone: '/brand/checkBUserPhone'
                }
            },
        }
    },
    mounted(){
        this.getData();
    },
    methods:{
        //获取账号信息
        getData(){
            this.dataLoading = true;
            this.$request({
                url: this.action[this.userType].accountInfo,
                method: "POST",
                data: {id: this.userId},
            })
                .then((res) => {
                    //处理成功回调
                    const { state, msg, result } = res.data;
                    if (state && state == 1) {
						console.log(result.loginName)
                        this.formData = {
                            ...defaultFormData,
                            ...result,
                            userType: this.userType,
                            telephone: result.telephone && result.telephone.includes('tmp') ? '' : result.telephone || ''
                        };
                        // 网易云音乐艺人ID已移至开通服务中，账号保存不再提交该字段
                        delete this.formData.neteaseCloudKey;
                        this.$emit('update:userName',result.name)
                    } else {
                        return this.$message.error(msg || "获取账号信息失败");
                    }
                }).catch(() => {
                    return this.$message.error("获取账号信息失败");
                })
                .finally(() => {
                    this.dataLoading = false;
                });
        },
        //表单提交
        onSubmit() {
            this.$refs["formData"].validate((valid) => {
                if (valid) {
                    if( this.formData.telephone ){
                        this.btnLoading = true;
                        this.$request({
                            url: this.action[this.userType].checkBUserPhone,
                            method: "POST",
                            data: {
                                id: this.userId,
                                telephone: this.formData.telephone
                            },
                        })
                            .then((res) => {
                                //处理成功回调
                                const { state, msg, result } = res.data;
                                //result: 0 未使用  1 被乐迷占用  2 被B类用户占用
                                if (state && state == 1) {
                                    if(result == 0){
                                        this.onSave();     
                                    }
                                    if(result == 1){
                                        this.$confirm('当前手机号已被乐迷账户占用,如果继续提交,会将乐迷账户的手机号清除 (该乐迷账号将无法使用该手机号登录秀动)', '提示', {
                                            type: 'warning',
                                            center: true,
                                            confirmButtonText:'继续提交',
                                            cancelButtonText:'返回修改',
                                            closeOnClickModal: false
                                        }).then(() => {
                                            this.onSave();  
                                        }).catch(() => {})
                                    }
                                    if(result == 2){
                                        this.$confirm('当前手机号已被其他B类用户占用', '提示', {
                                            type: 'warning',
                                            center: true,
                                            showConfirmButton: false,
                                            cancelButtonText:'返回修改',
                                            closeOnClickModal: false
                                        }).then(() => {
                                            
                                        }).catch(() => {})
                                    }
                                } else {
                                    return this.$message.error(msg || "操作失败");
                                }
                            })
                            .finally(() => {
                                this.btnLoading = false;
                            });
                    }else{
                        this.onSave();
                    }
                }
            });
        },
        onSave(){
            this.btnLoading = true;
            this.$request({
                url: this.action[this.userType].saveAccount,
                method: "POST",
                data: this.formData,
            })
                .then((res) => {
                    //处理成功回调
                    const { state, msg } = res.data;
                    if (state && state == 1) {
                        this.$message.success("操作成功");
                    } else {
                        return this.$message.error(msg || "操作失败");
                    }
                })
                .finally(() => {
                    this.btnLoading = false;
                });
        }
    }
}
</script>